window.Vue = require('vue');

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons'
import DatePicker from 'vue2-datepicker'

import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'

import select2 from 'select2';
import 'select2/dist/css/select2.min.css';

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('D MMMM Y');
  }
});

Vue.filter('cifer', (val) => {
  return val.toLocaleString('ru');
});

Vue.component('cat-card', require('./components/commerce/cat-card.vue'));
Vue.component('product', require('./components/commerce/product.vue'));
Vue.component('side-filter', require('./components/commerce/side-filter.vue'));
Vue.component('account-register', require('./components/commerce/account-register.vue'));
Vue.component('account-login', require('./components/commerce/account-login.vue'));
Vue.component('account-changedata', require('./components/commerce/account-changedata.vue'));
Vue.component('make-link', require('./components/commerce/account-makelink.vue'));
Vue.component('category', require('./components/commerce/category.vue'));
//Vue.component('lent-prod', require('./components/commerce/lent-prod.vue'));
Vue.component('top-cart', require('./components/commerce/top-cart.vue'));
Vue.component('big-cart', require('./components/commerce/big-cart.vue'));
Vue.component('curator-users', require('./components/commerce/curator-users.vue'));


UIkit.use(Icons);

/* Yandex */
let Yacounter = {
  num: '51115889',
  goal: 'ZAYKA'
};

const app = new Vue({
  el: '#app',
  data: {
    /* SYSTEM VARS */
    loaded: false,
    modal: {
      title: "Заказать звонок",
      button: 'Отправить',
      theme: 'Заявка',
      vopr: false,
    },
    confid: true,
    /* COMMERCE VARS */
  },
  computed: {},
  methods: {
    /* SYSTEM FUNCTIONS */
    setModal(title = 'Заявка', theme = 'Заявка', button = 'Отправить', vopr = false, bron = false) {
      let modal = {
        title,
        button,
        theme,
        vopr,
        bron
      };
      this.modal = modal;
      //console.log(modal);
    },
    counter() {
      if (typeof (window['yaCounter' + Yacounter.num]) !== "undefined") {
        console.log('Счетчик сработал');
        window['yaCounter' + Yacounter.num].reachGoal(Yacounter.goal);
      } else {
        console.log('Счетчик неопределен');
      }
    },
    sendForm(event) {
      let fd = {};
      let form = $(event.target);
      form.serializeArray().forEach(function (element) {
        fd[element.name] = element.value;
      });

      let app = this;
      let formdata = {
        form: fd
      };


      console.log(fd);
      $.request('onSend', {
        data: fd,
        success: function (data) {
          //... do something ...
          console.log(data);
          //this.success(data);
        },
        error: function (err) {
          console.log(err);
        }
      })

      /*$.ajax({
        type: 'POST',
        url: init.theme + '/mail.inc.php',
        data: fd,
        success: function (data) {
          console.log(data);
          form[0].reset();
          app.counter();
          app.thanks();
        },
        error: function (xhr, str) {
          alert('Возникла ошибка: ' + xhr.responseCode);
        }
      });*/
    },
    thanks() {
      UIkit.modal('#thanksmodal').show();
    },
    autoModal() {
      let app = this;
      $('.js-modal').on('click', function () {
        let text = $(this).text();
        let modal = {
          title: text,
          button: 'Отправить',
          theme: text
        };
        app.modal = modal;
        UIkit.modal('#ordermodal').show();
      });
    },
    openLightbox(el) {
      UIkit.lightbox(el).show();
    },
    maps() {
      let map = L.map('mapblock').setView([55.79788757, 49.11057300], 13);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: ''
      }).addTo(map);

      L.marker([55.79788757, 49.11057300]).addTo(map)
      .bindPopup('Офис компании Матирос')
      .openPopup();

      map.scrollWheelZoom.disable();

      map.on('click', function () {
        if (!map.scrollWheelZoom.enabled()) {
          map.scrollWheelZoom.enable();
        }
      });
      map.on('mouseout', function () {
        map.scrollWheelZoom.disable();
      });
      if ($(window).width() > 768) {
        map.panBy(new L.Point(-250, 0));
      } else {
        //map.panBy(new L.Point(-250, 0));
      }
    },
    gallery(){
      let el = $('.js-gallery');
      if(el.length > 0){
        UIkit.lightbox('.js-gallery', {
          animation: 'fade'
        });
      }
    }
    /* COMMERCE FUNCTIONS */
  },
  components: { DatePicker },
  mounted() {
    this.gallery();
    //this.autoModal();
  }
});


// WEBPACK FOOTER //
// ./themes/oprava/src/js/app.js